module.exports = __webpack_public_path__ + "img/feedback_list3.898b1226.png";